import React from 'react'; 
import pendingIcon from '../images/Pending.png';
import greenIcon from '../images/Complete.png';
import CusGreenBtn from '../components/CusGreenBtn';
import config from '../appconfig/config.json'
 
const UploadStatus = (props) => {
    const {firstIconGreen,secIconGreen,thridIconGreen}  = props;

    const handleUploadDocs = () => {
        // console.log('handleUploadDocs');
        props.history.push(config.route.UploadDetails);
    }

    return(
        <div className='upload-status-div'>
            <div className="row around-xs inputPair">
                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                    <div className="bbline">
                        {'Upload the following documents now to speed up the process (optional)'}
                    </div>
                </div>
            </div>
            <br/> 
            <div className='m-wdt-95'>
            <div className="row around-xs inputPair">
                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                    <div style={{display:'-webkit-inline-box'}}>
                        <div>
                            <img className='upload-left-icon-size' src={firstIconGreen?greenIcon:pendingIcon} alt='cert' />&nbsp;&nbsp;&nbsp;
                        </div>
                        <span>{"Latest 2 Years Financial Report: Company's profit & loss and balance sheet"}</span>
                    </div>
                </div>
            </div>

            <div className="row around-xs inputPair">
                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                    <div style={{display:'-webkit-inline-box'}}>
                        <div>
                            <img className='upload-left-icon-size' src={secIconGreen?greenIcon:pendingIcon} alt='cert' />&nbsp;&nbsp;&nbsp;
                        </div>
                        <span>{"Latest 6 Months Operating Bank Statement: Primary account for business transactions"}</span>
                    </div>
                </div>
            </div>

            <div className="row around-xs inputPair">
                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                    <div style={{display:'-webkit-inline-box'}}>
                        <div>
                        <img className='upload-left-icon-size' src={thridIconGreen?greenIcon:pendingIcon} alt='cert' />&nbsp;&nbsp;&nbsp;
                        </div>
                       
                        <span>{"Option to Purchase (OTP) - for property only"}</span>
                    </div>
                </div>
            </div>

            </div>
      
            <br/>
            <CusGreenBtn lbtxt='Upload Documents' onClick={handleUploadDocs} />
        </div>
    )
}

export default UploadStatus;